var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-fab-transition", [
    _vm.canShow
      ? _c(
          "div",
          {
            staticClass: "v-application",
            attrs: { "data-app": "" },
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c(
              "v-menu",
              {
                ref: "menu-chat",
                attrs: {
                  "close-on-content-click": false,
                  "nudge-width": 300,
                  "offset-y": "",
                  "offset-overflow": "",
                  rounded: "lg"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        var value = ref.value
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.show_chat,
                                      expression: "show_chat"
                                    }
                                  ],
                                  staticClass: "dont-show-print",
                                  attrs: { dark: "", fab: "" }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              !value
                                ? _c(
                                    "div",
                                    [
                                      _c("icon-svg", {
                                        attrs: { name: "chats" }
                                      }),
                                      _vm.$store.getters["chat/allUnread"]
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "elevation-10",
                                              staticStyle: {
                                                position: "absolute",
                                                top: "-20px",
                                                right: "0",
                                                background: "white",
                                                color: "var(--primary)",
                                                "border-radius": "20px",
                                                padding: "0px 4px 3px"
                                              }
                                            },
                                            [
                                              _c("small", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$store.getters[
                                                      "chat/allUnread"
                                                    ]
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              value
                                ? _c(
                                    "div",
                                    [_c("v-icon", [_vm._v("mdi-close")])],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2406086828
                ),
                model: {
                  value: _vm.menu_chat,
                  callback: function($$v) {
                    _vm.menu_chat = $$v
                  },
                  expression: "menu_chat"
                }
              },
              [
                _c(
                  "v-card",
                  { staticStyle: { "min-height": "500px" } },
                  [
                    _c(
                      "v-stepper",
                      {
                        model: {
                          value: _vm.step_chat,
                          callback: function($$v) {
                            _vm.step_chat = $$v
                          },
                          expression: "step_chat"
                        }
                      },
                      [
                        _c(
                          "v-stepper-header",
                          {
                            staticClass: "elevation-10 text-white",
                            staticStyle: {
                              "background-color": "var(--primary)"
                            }
                          },
                          [
                            _vm.step_chat === "1"
                              ? _c(
                                  "div",
                                  [_c("v-card-title", [_vm._v(" Workspace ")])],
                                  1
                                )
                              : _vm._e(),
                            _vm.step_chat === "2"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-card-title",
                                      { staticStyle: { width: "368px" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "full-center flex-row justify-content-between",
                                            staticStyle: { width: "100%" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "full-center flex-row",
                                                staticStyle: {
                                                  "max-width": "95%"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.clearRoomSelection
                                                    }
                                                  },
                                                  [_vm._v(" mdi-chevron-left ")]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "mb-0",
                                                    staticStyle: {
                                                      "white-space": "nowrap",
                                                      "text-overflow":
                                                        "ellipsis",
                                                      overflow: "hidden"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.room.nome) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-menu",
                                                  {
                                                    ref: "listaMenu",
                                                    attrs: {
                                                      bottom: "",
                                                      left: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  {
                                                                    attrs: {
                                                                      icon: ""
                                                                    }
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "white"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " mdi-dots-vertical "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      1150403842
                                                    ),
                                                    model: {
                                                      value: _vm.showMenu,
                                                      callback: function($$v) {
                                                        _vm.showMenu = $$v
                                                      },
                                                      expression: "showMenu"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list",
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            on: {
                                                              click:
                                                                _vm.showDetailsRoom
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              [
                                                                _vm._v(
                                                                  " Detalhes "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        !_vm.online
                          ? _c("p", { staticClass: "m-10" }, [
                              _c(
                                "small",
                                { staticClass: "text-bold text-danger" },
                                [
                                  _vm._v(
                                    " Você está offline. Estamos tentando reconectar. "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _c(
                          "v-stepper-items",
                          {
                            staticStyle: {
                              height: "444px",
                              "overflow-y": "auto"
                            }
                          },
                          [
                            _c(
                              "v-stepper-content",
                              { staticClass: "p-0", attrs: { step: "1" } },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "px-3 mt-3" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            filled: "",
                                            "append-icon": "search",
                                            dense: "",
                                            height: "60",
                                            "hide-details": "",
                                            placeholder: "Pesquisar canais"
                                          },
                                          model: {
                                            value: _vm.filterRooms,
                                            callback: function($$v) {
                                              _vm.filterRooms = $$v
                                            },
                                            expression: "filterRooms"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list",
                                      [
                                        _c(
                                          "v-list-item-group",
                                          {
                                            model: {
                                              value: _vm.index_room,
                                              callback: function($$v) {
                                                _vm.index_room = $$v
                                              },
                                              expression: "index_room"
                                            }
                                          },
                                          [
                                            _vm.roomsColective.length
                                              ? _c(
                                                  "v-subheader",
                                                  { staticClass: "text-bold" },
                                                  [_vm._v(" Canais Coletivos ")]
                                                )
                                              : _vm._e(),
                                            _vm.roomsColective.length
                                              ? _vm._l(
                                                  _vm.roomsColective,
                                                  function(s) {
                                                    return _c(
                                                      "v-list-item",
                                                      {
                                                        key: s.nome,
                                                        staticClass:
                                                          "v-application",
                                                        on: {
                                                          click: function() {
                                                            _vm.room = s
                                                            _vm.step_chat = "2"
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "full-center justify-content-between",
                                                            staticStyle: {
                                                              width: "100%",
                                                              "flex-direction":
                                                                "row"
                                                            }
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    s.nome
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]),
                                                            s.unread_quantity
                                                              ? _c(
                                                                  "v-chip",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "primary",
                                                                      "x-small":
                                                                        ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          s.unread_quantity
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _vm._e(),
                                            _vm.roomsColective.length &&
                                            _vm.roomsIndividuals.length
                                              ? _c("v-divider")
                                              : _vm._e(),
                                            _vm.roomsIndividuals.length
                                              ? _c(
                                                  "v-subheader",
                                                  { staticClass: "text-bold" },
                                                  [
                                                    _vm._v(
                                                      " Canais Individuais "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.roomsIndividuals.length
                                              ? _vm._l(
                                                  _vm.roomsIndividuals,
                                                  function(s) {
                                                    return _c(
                                                      "v-list-item",
                                                      {
                                                        key: s.nome,
                                                        on: {
                                                          click: function() {
                                                            _vm.room = s
                                                            _vm.step_chat = "2"
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "full-center justify-content-between",
                                                            staticStyle: {
                                                              width: "100%",
                                                              "flex-direction":
                                                                "row"
                                                            }
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    s.nome
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]),
                                                            s.unread_quantity
                                                              ? _c(
                                                                  "v-chip",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "primary",
                                                                      "x-small":
                                                                        ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          s.unread_quantity
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _c("div", { staticClass: "full-center" }, [
                                      !_vm.roomsColective.length &&
                                      !_vm.roomsIndividuals.length
                                        ? _c("p", [
                                            _vm._v(" Nenhum canal encontrado. ")
                                          ])
                                        : _vm._e()
                                    ])
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "v-stepper-content",
                              { staticClass: "p-0", attrs: { step: "2" } },
                              [
                                _c(
                                  "Card",
                                  {
                                    staticClass: "full-center p-0 m-0",
                                    staticStyle: { height: "444px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "chat-scroll",
                                            rawName: "v-chat-scroll",
                                            value: {
                                              always: false,
                                              smooth: true,
                                              scrollonremoved: false,
                                              notSmoothOnInit: true
                                            },
                                            expression:
                                              "{\n                    always: false,\n                    smooth: true,\n                    scrollonremoved: false,\n                    notSmoothOnInit: true,\n                  }"
                                          }
                                        ],
                                        staticStyle: {
                                          height: "370px",
                                          "overflow-y": "auto",
                                          "max-width": "400px",
                                          width: "100%"
                                        },
                                        attrs: {
                                          id: "historicoMensagensPopup"
                                        },
                                        on: {
                                          "v-chat-scroll-top-reached":
                                            _vm.loadMore
                                        }
                                      },
                                      [
                                        _vm.loadingMessages
                                          ? _c(
                                              "div",
                                              { staticClass: "v-application" },
                                              [
                                                _c("v-progress-circular", {
                                                  staticStyle: {
                                                    margin: "auto"
                                                  },
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "primary"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._l(_vm.messages, function(m) {
                                          return _c("ChatMessage", {
                                            key: m.token_sala + m.data_registro,
                                            attrs: { message: m }
                                          })
                                        })
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center justify-content-between",
                                        staticStyle: {
                                          width: "100%",
                                          padding: "5px"
                                        }
                                      },
                                      [
                                        _c("v-text-field", {
                                          ref: "campoMensagem",
                                          attrs: {
                                            autofocus: "",
                                            solo: "",
                                            rounded: "",
                                            flat: "",
                                            filled: "",
                                            "hide-details": "",
                                            placeholder: "Digite uma mensagem",
                                            readonly: !_vm.online
                                          },
                                          on: {
                                            keydown: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.sendMessage($event)
                                            }
                                          },
                                          model: {
                                            value: _vm.text_message,
                                            callback: function($$v) {
                                              _vm.text_message = $$v
                                            },
                                            expression: "text_message"
                                          }
                                        }),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "elevation-0 ml-3",
                                            attrs: {
                                              fab: "",
                                              color: "primary",
                                              "x-small": "",
                                              disabled: !_vm.online
                                            },
                                            on: { click: _vm.sendMessage }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-send")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }